import React, { Component } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"


import avatar1 from "../../assets/images/chart-kattami-bg.jpg"
import profileImg from "../../assets/images/profile-img.png"

class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div className="p-3 ">
                  <h5>Welcome to Kattam </h5>
                  <p>
                    Artificial Intelligence (AI) Report as a very important document which helps parents to predict and
                    explain the probable mental health issues of a new born baby or a child at the time of birth and
                    below 15 years. If you or any of your family members are suffering from above mentioned issues kindly
                    consult with our counsellors by mail us at <b>info@kattam.ai</b>.
                  </p>
                  <br />
				          <p>
                    If you want to change any of your profile or birth details
					          kindly by mail us on top of specified mailid with relevant information.
                  </p>
                  <p>
                    Get Your Artificial Intelligence (AI) Report,
                    Enter your birth date & time and birth place in the form by clicking the below button.
                  </p>
                  <div className="mb-4">
                    <Link
                      to="/generate-birthchart"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Generate AI Report {" "}<i className="mdi mdi-arrow-right ms-1" />
                    </Link>
                  </div>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody className="pt-0">
            <Row>
              <Col sm="4">
                <div className="avatar-md profile-user-wid mb-4">
                  <img
                    src={avatar1}
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 className="font-size-15 text-truncate"></h5>
                <p className="text-muted mb-0 text-truncate"></p>
              </Col>

              <Col sm="8">
                <div className="pt-4">
                  <Row>
                    <Col xs="6">
                      <h5 className="font-size-15"></h5>
                      <p className="text-muted mb-0"></p>
                    </Col>
                    <Col xs="6">
                      <h5 className="font-size-15"></h5>
                      <p className="text-muted mb-0"></p>
                    </Col>
                  </Row>

                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment >
    )
  }
}

export default WelcomeComp
